













































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { Component, Vue, Emit, PropSync } from 'vue-property-decorator';
import { regionServe, getArea } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';

@Component({
  components: { CollapseTransition, TreeUnit },
  mixins: [TableStripe],
})
export default class RegionIndex extends Vue {
  @PropSync('showFlag', Number) pageFlag!: number; // 显示哪个页面
  @PropSync('row', Object) editRow!: string; // 向编辑页面传递的值

  formShow = false; // 查询表单是否显示

  openAsideFlag = true; // 侧边栏是否打开
  // 表单数据对象
  formData: object = {
    name: undefined, // 区域
  };

  formData1: any = {
    bsAreaCode: '',
    bsStreetCode: '',
    name: '',
    bsAreaName: '',
    bsStreetName: '',
    describe: '',
    display: false,
    enable: false,
    id: '',
    pid: '',
    planImagePath: '',
    sort: 0,
  };
  rules1: any = {
    name: [{ required: true, message: '请输入区域名称', trigger: 'blur' }],
  };

  // table表格数据对象
  tableData: any[] = [];
  rowId = '';

  // dialog中的数据
  dialogVisible: any = false;
  dialogTitle = ''; // dialog 的标题
  areaList: any = [];
  streetList: any = [];
  dialogAreaList: any = [];
  dialogStreetList: any = [];
  flagArea: any = false;
  flagStreet: any = false;

  antiShake = true; // 控制防抖
  areaListTree: any = [];
  private getAreaListData() {
    regionServe
      .getRegionAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.areaListTree = arrayToTree(res.data);
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('获取数据失败！');
      });
  }

  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds(data: any) {
    this.getAllData({});
  }

  // Vue 数据创建生命周期钩子函数
  created() {
    // 初始化所有空间数据
    this.getAllData({});
    this.getAreaList();
    // this.getCode(330182);
  }

  /**
   * @desc 获取所有区的数据
   * @returns 暂无
   */
  getAreaList() {
    getArea
      .getArea()
      .then((res: any) => {
        if (res.code === '200') {
          this.areaList = res.data;
        }
      })
      .catch(() => {
        this.$message.error('初始化空间数据失败,请稍后重试!');
      });
  }

  getStreetList(code: any) {
    getArea
      .getStreet(code)
      .then((res: any) => {
        if (res.code === '200') {
          this.streetList = res.data;
        }
      })
      .catch(() => {
        this.$message.error('初始化空间数据失败,请稍后重试!');
      });
  }

  /**
   * @desc 获取空间所有数据
   * @param1 data：用来筛选数据的条件对象
   * @returns 暂无
   */
  getAllData(data: any) {
    regionServe
      .getRegionAllDataManage(data)
      .then((res: any) => {
        if (res.code === '200') {
          // console.log(res.data);
          this.tableData = arrayToTree(res.data);
        }
      })
      .catch(() => {
        this.$message.error('初始化空间数据失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏和显示按钮，切换搜索表单显示状态。
   * @param1 暂无
   * @returns 暂无
   */
  setFormShow() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件数据。
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.getAllData(this.formData); // 查询符合条件的数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击重置按钮触发，重置搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields(); // 重置表单
    this.getAllData({}); // 重置所有数据
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击展开或折叠按钮触发，展开或折叠 table 树状图
   * @param1 暂无
   * @returns 暂无
   */
  toggleTableTree(flag: boolean) {
    // 展开或折叠所有 table
    this.forArr(this.tableData, flag);
  }

  /**
   * @desc 递归函数，展开全部 table 内容
   * @param1 data：需要循环的数据
   * @param2 flag：判断展开还是折叠
   * @returns 暂无
   */
  forArr(data: any[], flag: boolean) {
    data.forEach(item => {
      (this.$refs.tableRef as any).toggleRowExpansion(item, flag);
      if (item.children) {
        this.forArr(item.children, flag);
      }
    });
  }

  /**
   * @desc 点击删除区域触发，删除该行区域
   * @param1 id：要删除的区域的id
   * @returns 暂无
   */
  deleteCompany(id: string) {
    this.$confirm('确认要删除该空间吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        // 删除空间
        regionServe
          .delRegionData(id)
          .then((res: any) => {
            if (res.code == '200') {
              this.$message.success('删除成功!');
              // 刷新数据
              this.getAllData({});
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {
            this.$message.error('删除失败,请稍后重试！');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  openDrawMap(title: string, row: any) {
    // console.log(row);
    this.editRow = row; // 给编辑页面传递需要修改的id
    this.pageFlag = 2; // 进入编辑页面
  }

  /**
   * @desc 打开区域添加/修改弹窗
   * @param1 title：弹窗标题   row：修改/新增时传入的数据
   * @returns 暂无
   */
  async openDialog(title: string, row: any) {
    this.dialogTitle = title; // 设置 dialog 的标题
    this.dialogVisible = true; // 显示 dialog
    if (title === '新增区域') {
      this.dialogAreaList = this.areaList;
    } else if (title === '新增下级区域') {
      this.formData1.bsAreaCode = row.bsAreaCode;
      this.formData1.bsStreetCode = row.bsStreetCode;
      this.formData1.pid = row.id;
      this.dialogAreaList = this.areaList;
      if (this.formData1.bsAreaCode) {
        const res = await getArea.getStreet(this.formData1.bsAreaCode);
        if (res.code !== '200') throw new Error();
        this.streetList = res.data;
        setTimeout(() => {
          if (this.streetList) {
            this.dialogStreetList = this.streetList;
          }
        }, 0);
        this.flagArea = true;
      }
      if (this.formData1.bsStreetCode) {
        this.flagStreet = true;
      }
    } else if (title === '编辑区域') {
      this.formData1 = row;
      console.log(this.formData1);
      // this.formData1.bsAreaCode = row.bsAreaCode;
      // this.formData1.bsStreetCode = row.bsStreetCode;
      // this.formData1.name = row.name;
      this.getAreaListData();
      this.dialogAreaList = this.areaList;
      if (this.formData1.bsAreaCode) {
        const res = await getArea.getStreet(this.formData1.bsAreaCode);
        if (res.code !== '200') throw new Error();
        this.streetList = res.data;
        setTimeout(() => {
          if (this.streetList) {
            this.dialogStreetList = this.streetList;
          }
        }, 0);
      }
      if (row.children) {
        this.flagArea = true;
        this.flagStreet = true;
      } else {
        if (row.pid) {
          this.tableData.forEach((item: any) => {
            if (item.id === row.pid) {
              console.log(item);
              if (item.bsAreaCode) {
                this.flagArea = true;
              }
              if (item.bsStreetCode) {
                this.flagStreet = true;
              }
            }
          });
        }
      }
    }
  }

  /**
   * @desc 关闭区域弹窗
   * @returns 暂无
   */
  closeDialog() {
    this.dialogVisible = false; // 关闭 dialog
    this.dialogAreaList = [];
    this.dialogStreetList = [];
    this.formData1 = {
      bsAreaCode: '',
      bsStreetCode: '',
      name: '',
      bsAreaName: '',
      bsStreetName: '',
      describe: '',
      display: false,
      enable: false,
      id: '',
      pid: '',
      planImagePath: '',
      sort: 0,
    };
    this.flagArea = false;
    this.flagStreet = false;
  }

  /**
   * @desc formData1数据整理
   * @returns 暂无
   */
  async changeDialogArea(code: any) {
    this.formData1.bsStreetCode = '';
    if (code) {
      // this.getCode(code);
      const res = await getArea.getStreet(code);
      if (res.code !== '200') throw new Error();
      this.streetList = res.data;
      setTimeout(() => {
        if (this.streetList) {
          this.dialogStreetList = this.streetList;
        }
      }, 0);
    }
  }

  /**
   * @desc 区域新建/修改 时的取消按钮
   * @returns 暂无
   */
  dialogCancel() {
    this.closeDialog();
  }

  getRequestData(data: any) {
    const requestData: any = {};
    if (data.bsAreaCode) {
      this.dialogAreaList.forEach((item: any) => {
        if (item.areaCode === data.bsAreaCode) {
          (requestData as any).bsAreaCode = item.areaCode;
          (requestData as any).bsAreaName = item.areaName;
        }
      });
    } else {
      (requestData as any).bsAreaCode = '';
      (requestData as any).bsAreaName = '';
    }
    if (data.bsStreetCode) {
      this.dialogStreetList.forEach((item: any) => {
        if (item.streetCode === data.bsStreetCode) {
          (requestData as any).bsStreetCode = item.streetCode;
          (requestData as any).bsStreetName = item.streetName;
        }
      });
    } else {
      (requestData as any).bsStreetCode = '';
      (requestData as any).bsStreetName = '';
    }
    (requestData as any).name = data.name;
    (requestData as any).describe = data.describe;
    (requestData as any).display = data.display;
    (requestData as any).enable = data.enable;
    (requestData as any).id = data.id;
    (requestData as any).pid = data.pid;
    (requestData as any).planImagePath = data.planImagePath;
    (requestData as any).sort = data.sort;
    return requestData;
  }

  /**
   * @desc 区域新建/修改 时的保存按钮
   * @returns 暂无
   */
  dialogSave() {
    const data = this.getRequestData(this.formData1);
    console.log(data);
    if (data.name === '') {
      this.$message.warning('请输入区域名称!');
    } else {
      if (this.dialogTitle === '编辑区域') {
        regionServe
          .editRegionData(data)
          .then((res: any) => {
            if (res.code === '200') {
              this.closeDialog();
              this.$message.success('修改成功!');
              this.getAllData({});
            }
          })
          .catch(() => {
            this.$message.error('保存失败,请重试!');
          });
      } else {
        regionServe
          .addRegionData(data)
          .then((res: any) => {
            if (res.code === '200') {
              this.closeDialog();
              this.$message.success('保存成功!');
              this.getAllData({});
            }
          })
          .catch(() => {
            this.$message.error('保存失败,请重试!');
          });
      }
    }
  }
}
